import { Component, OnInit } from '@angular/core';
import { combineLatest } from 'rxjs';
import { InternalSettingsService } from 'src/app/common/services/internal-settings/internal-settings.service';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { Banner, Category, Placement } from '../me-marketing-banner/me-marketing-banner-bean';
import { MeMarketingBannerService } from '../me-marketing-banner/me-marketing-banner.service';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';
import { InternalSettings } from '../../services/internal-settings/internal-settings.interface';
import { PermittedActivityService } from '../../services/permitted-activity/permitted-activity.service';
import { PlatformService } from 'src/app/system/utility/platform.service';
import { EnvironmentService } from 'src/app/system/utility/environment.service';
import { PAMenuDesktop, PASection } from '../../services/permitted-activity/pa-menu-meta';
import { KeyValue } from '@angular/common';
import { InAppBrowserService } from 'src/app/system/utility/in-app-browser.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.less'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  externalSettings!: ExternalSettings;
  internalSettings!: InternalSettings;
  permissionCodes: number[] = [];
  menu!: PAMenuDesktop;
  banner!: Banner;

  constructor(
    private srvES: ExternalSettingsService,
    private srvIS: InternalSettingsService,
    private srvBanner: MeMarketingBannerService,
    private srvPermitted: PermittedActivityService,
    private srvInAppBrowser: InAppBrowserService,
  ) {}

  ngOnInit(): void {

    combineLatest([
      this.srvES.externalSettings$,
      this.srvIS.getCurrentSettings(),
      this.srvBanner.getWebBanner(Category.DEFAULT, Placement.SIDE),
      this.srvPermitted.menuDesktop$
    ]).subscribe(([es, is, banner, menuDesktop]) => {

      // Load the PermissionCodes
      this.externalSettings = es;
      this.internalSettings = is;

      // Set Banner
      this.initBanner(banner);
      this.menu = menuDesktop!;
    });

  }

  private initBanner(banner: Banner) {
    if (banner && PlatformService.isMobile()) {
      banner.image = EnvironmentService.getBaseUrl() + banner.image;
    }
    this.banner = banner;
  }

  protected accessBanner(): void {
    if (!this.banner) return;

    if (this.banner.link) {

      this.srvBanner.accessBanner(this.banner);

      // Open the Link
      this.srvInAppBrowser.openExternalBrowser(this.banner.link);
    }
  }

  compareFn = (a: KeyValue<string, PASection>, b: KeyValue<string, PASection>): number => {
    return a.value.index - b.value.index;
  };
}